/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { htmlspecialchars, str_trim } from './util.js';
import { mjt } from './i18ntexts.js';
import { jQuery } from '../other/jquery-hooked.js';
import { postToBackend } from './fetch-util.js';
import { showErrorToast } from './snackbar.js';


export let MValueLists = function($) {

	var max_display_item_count = 15,
		display_item_height = 20
		;

	function Destroy() {
		$(document).off('keydown.mvl');
		$('#mvl-values')
			.children('.md-v-up').stopTime('md-v-up').end()
			.children('.md-v-down').stopTime('md-v-down').end()
			.remove();
		$('#mvl-values-shadow').remove();
	}

	return {
		Destroy: Destroy,
		getTriggerHTML: function() {
			return '<div class="wrap-mvl-dd"><span class="values-dropdown" title="'+mjt('md-select-value')+'"></span></div>';
		},
		Bind: function( outer_elem, trigger_elem, meta_id, separator, replace_ml_text_mode ) {
			trigger_elem.click( function() {
				var self=$(this),
					mj_target_name=self.attr('mj_target_name'),
					o=self.offset(),
					x=o.left-220+17, y=o.top+self.height(),
					w=220, h=max_display_item_count*display_item_height
					;
				if( typeof mj_target_name == 'undefined' ) mj_target_name = 'data';

				var scroll_to_pos = function( top ) {
					var inner = $('#mvl-values-inner'),
						iheight = inner.height()||0,
						oheight = inner.parent().height()||0,
						mddv = $('#mvl-values'),
						vup = mddv.children('.md-v-up'),
						vdown = mddv.children('.md-v-down')
						;
					if( iheight > oheight ) {
						if( top + iheight <= oheight ) {
							top = oheight - iheight; // lower boundary reached
							vdown.removeClass('link active');
						} else {
							vdown.addClass('link active');
						}
						if( top >= 0 ) {
							top = 0;
							vup.removeClass('link active');
						} else {
							vup.addClass('link active');
						}
						inner.css('top',top.toString()+'px');
					} else {
						vdown.removeClass('link active');
						vup.removeClass('link active');
					}
				};
				var scroll_to_idx = function( idx ) {
					var trg = $('#mvl-values-inner').children('[mj_idx='+idx+']');
					if( trg.length ) scroll_to_pos( Math.round(-trg.position().top) );
				};
				var scroll_delta = function( delta ) {
					scroll_to_pos( parseInt($('#mvl-values-inner').css('top'),10) + display_item_height*delta );
				};
				var decay_effect = function() {
					$('#mvl-values-shadow').fadeOut('fast');
					$('#mvl-values').fadeOut('fast', function() {
						$(this)
							.children('.md-v-up').stopTime('md-v-up').end()
							.children('.md-v-down').stopTime('md-v-down').end()
							.remove()
						;
					} );
					$(document).off('keydown.mvl');
				};

				Destroy();

				var mddv = $('<div id="mvl-values" />').css({left:x+'px',top:y+'px',width:w+'px',height:(h+2*15)+'px'}),
					mddvc = $('<div id="mvl-values-outer" style="height:'+h.toString()+'px"></div>').appendTo(mddv),
					mddvc1 = $('<div id="mvl-values-inner"></div>').appendTo(mddvc)
					;
				mddv.append('<div class="md-v-up"></div><div class="md-v-down"></div>')
					.appendTo('body')
					.fadeIn('fast') //.show()
				;

				// add handler for ESCAPE key (close mvl & avoid ui dialog to handle the keypress too)
				// -> setting tabindex makes the div focusable
				// -> setting outline to 0 prevents a border on focus in Mozilla
				// -> calling focus() will actually focus() the div
				mddv.attr('tabindex',-1).css('outline',0).focus()
					.keydown( function(e) {
						if( !e.isDefaultPrevented() && e.keyCode && e.keyCode===27 ) {
							outer_elem.find('input[type=text][name=\''+mj_target_name+'\'],textarea[name=\''+mj_target_name+'\']').focus();
							// --> triggers blur event
							e.preventDefault();
							e.stopPropagation();
						}
					})
					.blur( function(e) {
						outer_elem.find('input[type=text][name=\''+mj_target_name+'\'],textarea[name=\''+mj_target_name+'\']').focus();
						//decay_effect();
						e.preventDefault();
						e.stopPropagation();
					});

				// load data..
				postToBackend( 'json/media/meta-suggestions', 'meta_id='+meta_id, function(j) {
					if( !j || j.error ) {
						showErrorToast( 'Fehler, Daten konnten nicht geladen werden. ' + ( j ? j.error : '' ) );
						decay_effect();
					} else {

						var iw = w-2,
							html = '',
							idx = 0
							;
						var group_display_titles = {
							'defaults':			mjt('wdg-mvl-defaults'),
							'recently-used':	mjt('wdg-mvl-recently-used'),
							'alphabetically':	mjt('wdg-mvl-alphabetically'),
						};
						for( var g=0; g<j.groups.length; ++g ) {
							var grp=j.groups[g], jvl=grp.values.length, build_char_idx=false, last_cc=0;
							html += '<div mj_idx="'+idx+'" class="values-group" style="width:'+(iw-10)+'px">'+group_display_titles[grp.title]+'</div>';
							idx++;
							if( grp.title==='alphabetically' ) {
								build_char_idx = true;
							}
							for( var i=0; i<jvl; ++i ) {
								var cc_attr = '';
								if( build_char_idx ) {
									var first_cc = grp.values[i].charAt(0).toUpperCase().charCodeAt(0);
									if( first_cc!=last_cc ) {
										cc_attr = ' mj_cc="'+first_cc+'"';
										last_cc = first_cc;
									}
								}
								html += '<div mj_idx="'+idx+'" '+cc_attr+'class="values-item '+((i%2)==0?'even':'odd')+'" style="width:'+(iw-14)+'px">'+htmlspecialchars(grp.values[i])+'</div>';
								idx ++;
							}
						}
						var n = Math.min(idx,max_display_item_count);
						h = n * display_item_height;
						mddv.css('height',(h+2*15).toString()+'px');
						mddvc.css('height',h.toString()+'px');
						mddvc1
							.append(html)
							.children('.values-item')
							.click( function() {
								var text = $(this).text();
								var ta = outer_elem.find('textarea[name=\''+mj_target_name+'\']');
								if( ta.length ) {
									var cur_trimmed_text = str_trim(ta.val());
									if( replace_ml_text_mode ) {
										// nothing
									} else {
										if( cur_trimmed_text.length ) text = cur_trimmed_text + separator + text;
									}
									ta.val(text).focus();
								} else {
									var t1 = outer_elem.find('input[type=text][name=\''+mj_target_name+'\']');

									t1.val(text).focus();
								}
								decay_effect();
							} )
						;
						// move into visible screen area
						if( 2 + y + h+2*15 > $(window).height() ) {
							y -= 2 + y + h+2*15 - $(window).height();
							mddv.css('top',y+'px');
						}
						// shadow
						$('<div id="mvl-values-shadow"></div>')
							.css({ zIndex:parseInt(mddv.css('z-index'),10)-1,
								left:parseInt(mddv.css('left'),10)+8+'px', top:parseInt(mddv.css('top'),10)+8+'px',
								width:mddv.width()+'px', height:mddv.height()+'px',
								opacity:0.2 })
							.appendTo('body')
							.fadeIn('fast')
						;
						// anything else
						mddv.children('.md-v-down').css('top',(h+15)+'px');
						mddvc.slideDown( 'fast',
							function() {
								mddvc.css({top:'15px',height:h+'px'});
								mddvc1.css('top','0px');
								scroll_delta(0);
								mddvc1.mousewheel( function(ev,delta) {
									scroll_delta(delta);
								} );
								mddv.children('.md-v-up')
									.hover(	function() {
										$(this).everyTime('100ms','md-v-up',function(counter) {
											scroll_delta(+1);
										});
									},
									function() {
										$(this).stopTime('md-v-up'); scroll_delta(0);
									} )
									.end()
									.children('.md-v-down')
									.hover(	function() {
										$(this).everyTime('100ms','md-v-down',function(counter) {
											scroll_delta(-1);
										});
									},
									function() {
										$(this).stopTime('md-v-down'); scroll_delta(0);
									} )
									.end()
									.hover( function() {}, decay_effect )
								;
							}
						);
						// keyboard nav
						$(document).on( 'keydown.mvl', function( e ) {
							switch( e.which ) {
							case 38: // up
								scroll_delta(+1);
								break;
							case 40: // down
								scroll_delta(-1);
								break;
							case 33: // page up
								scroll_delta(+max_display_item_count);
								break;
							case 32: // space
							case 34: // page down
								scroll_delta(-max_display_item_count);
								break;
							case 27: // escape
								//if( !evt.isDefaultPrevented() ) {
								outer_elem.find('input[type=text][name=\''+mj_target_name+'\'],textarea[name=\''+mj_target_name+'\']').focus();
								decay_effect();
								e.preventDefault();
								e.stopPropagation();
								//}
								break;
							default:
								// characters & numbers
								if( ( e.which>=48 && e.which<=57 ) || ( e.which>=65 && e.which<=90 ) ) {
									var idx = mddvc1.children('.values-item[mj_cc='+e.which.toString()+']').attr('mj_idx');
									if( idx ) scroll_to_idx(idx);
								}
							}
						} );
					}
				});

				return false;
			}); // .click(..
		}, // function Bind
	};

}(jQuery); // namespace MValueLists
